var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "email-subject" },
    [
      _c("a-input", {
        attrs: { placeholder: "Subject" },
        scopedSlots: _vm._u([
          {
            key: "prefix",
            fn: function () {
              return [
                _c("div", { staticClass: "material-icons" }, [_vm._v("title")]),
              ]
            },
            proxy: true,
          },
        ]),
        model: {
          value: _vm.cloneValue,
          callback: function ($$v) {
            _vm.cloneValue = $$v
          },
          expression: "cloneValue",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }